import { RHFControl, RHFPhoneInput, RHFSelect } from 'components/common/form';
import { Card, Col, Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

const relationshipOptions = [
  { label: 'Parent', value: 'Parent' },
  { label: 'Sibling', value: 'Sibling' },
  { label: 'Grandparent', value: 'Grandparent' },
  { label: 'Aunt / Uncle', value: 'Aunt / Uncle' },
  { label: 'Cousin', value: 'Cousin' },
  { label: 'Family Friend', value: 'Family Friend' },
  { label: 'Other', value: 'Other' }
];

export const NextOfKinDetails = ({
  sectionRef,
  sideNavLink,
  locationCountry
}) => {
  return (
    <Card className="border shadow-none mb-3" ref={sectionRef} id={sideNavLink}>
      <Card.Header className="pb-0">
        <div className="dFlexRowStartSpace pt-3">
          <Card.Title as="h5">Next of Kin</Card.Title>
        </div>
      </Card.Header>
      <Card.Body>
        <Container className="p-0 d-flex flex-column g-3">
          <Row className="gx-3">
            <Col xs={12} sm={6} md={4}>
              <RHFControl name="nextOfKin.first_name" label="First Name" />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFControl name="nextOfKin.middle_name" label="Middle Name" />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFControl name="nextOfKin.last_name" label="Last Name" />
            </Col>
          </Row>
          <Row className="gx-3 mt-2">
            <Col xs={12} sm={6} md={4}>
              <RHFSelect
                name="nextOfKin.relationship"
                label="Relationship"
                options={relationshipOptions}
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFPhoneInput
                name="nextOfKin.phone"
                label="Contact Number"
                defaultCountry={locationCountry}
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFControl name="nextOfKin.email" label="Contact Email" />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <RHFControl
                name="nextOfKin.address"
                as="textarea"
                rows={2}
                label="Address"
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <RHFControl
                name="nextOfKin.notes"
                as="textarea"
                rows={2}
                label="Additional Notes"
              />
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
};

NextOfKinDetails.propTypes = {
  sectionRef: PropTypes.object,
  sideNavLink: PropTypes.string,
  locationCountry: PropTypes.string
};
